import clsx from 'clsx';
import MutedText from 'components/common/MutedText';
import HubertInput from 'components/HubertUI/HubertInput';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { updateInterviewSummaryDetailLabelByQuestionId } from 'rtk/TemplateSlice';
import { EEventType } from 'types/events.enum';
import { selectQuestionLanguage, selectQuestionPresentation } from 'rtk/questionEditorSelector';
import { useTemplateId } from 'hooks/useTemplate';
import { useQuestionEditorContext } from '../context/create-question.context';

const InTemplateInterviewSummaryLabel = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const questionPresentation = useAppSelector((state) => selectQuestionPresentation(state, questionId));
  const templateId = useTemplateId();

  const interviewSummaryBlocks = useAppSelector(
    (state) => state.Template?.present?.c?.interview_summary?.summary_blocks,
  );

  const derivedDetail = (() => {
    if (!interviewSummaryBlocks) return;
    for (const block of interviewSummaryBlocks) {
      if (!block.details) continue;
      const detail = block.details.find((d) => d?.id === questionId);
      if (detail) return { blockId: block.id, detail };
    }
  })();

  const derivedBlockId = derivedDetail?.blockId;

  const derivedLabel =
    (derivedDetail?.detail?.label?.length
      ? derivedDetail.detail.label
      : questionPresentation?.label?.[questionLanguage]) ?? '';

  const [labelState, setLabelState] = useState<{ questionId?: string; value: string }>({
    questionId: undefined,
    value: '',
  });

  const inputValue = labelState.questionId === questionId ? labelState.value : derivedLabel;

  return (
    <div className={clsx('flex flex-col justify-start gap-4', 'p-1')}>
      <div className={clsx('flex flex-row justify-start gap-4', 'hubert-vertical-center')}>
        <HubertLabel className="text-sm font-medium" htmlFor="create-question-presentation-label">
          {t('summaryLabel.label')}
        </HubertLabel>
        <HubertInput
          id="create-question-presentation-label"
          placeholder={t('summaryLabel.placeholder')}
          value={inputValue}
          onBlur={(e) => {
            const value = e.target.value;

            if (templateId && derivedBlockId && value && value.length) {
              dispatch(
                updateInterviewSummaryDetailLabelByQuestionId({
                  templateId,
                  eventType: EEventType.MODIFIED,
                  resource: {
                    blockId: derivedBlockId,
                    questionId,
                    newLabel: value,
                  },
                  description: `User updated summary label to question ${questionId}.`,
                }),
              );
            }
            setLabelState({ questionId: undefined, value: '' });
          }}
          onChange={(e) => {
            setLabelState({ questionId, value: e.target.value });
          }}
        />
      </div>
      <div className="">
        <MutedText text={t('summaryLabel.hint')} />
      </div>
    </div>
  );
};

export default InTemplateInterviewSummaryLabel;
